import styled from 'styled-components';
import mediaQueries from '@Utils/shared/constants/mediaQueries';

export const Wrapper = styled.div`
  margin-right: 20px;

  @media ${mediaQueries.mobile} {
    margin-right: 10px;
  }
`;

export const WrapperGroup = styled.div`
  padding: 0 25px;
  display: flex;

  @media ${mediaQueries.mobile} {
    padding: 0 15px;
  }
`;

export const Label = styled.label`
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: var(--bg-white);

  @media ${mediaQueries.mobile} {
    font-size: 14px;
  }
`;

export const Input = styled.input`
  position: absolute;
  z-index: -1;
  opacity: 0;

  & + label {
    display: flex;
    position: relative;
    padding: 0 0 0 30px;
    cursor: pointer;

    @media ${mediaQueries.mobile} {
      padding-left: 25px;
    }
  }

  & + label::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #26262c;
  }

  & + label::after {
    content: '';
    position: absolute;
    top: 5px;
    left: 5px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-image: linear-gradient(to bottom, #5486d6 0%, #3a6ab9);
    opacity: 0;
    transition: 0.2s;
  }

  &:checked + label::before {
    background: #26262c;
  }

  &:checked + label::after {
    opacity: 1;
  }
`;
